import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const AgendaContainer = styled.div`
    border: solid 1px ${ ({ theme: { listingProfessional } }) => listingProfessional };
`;

export const ButtonsContainer = styled(Col_)`
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;

    button {
        margin: 0 15px;
    }
`;

export const Col = styled(Col_)`
    margin-top: 10px;
    @media (min-width: 992px) {
        ${ ({ align }) => align ? `text-align: ${ align };` : '' }
    }
`;

export const Container = styled.div`
    height: 100%;
`;

export const DayLabel = styled.div`
    color: ${ ({ theme: { textColor } }) => textColor }
`;

export const DayRow = styled.div`
    align-items: center;
    display: flex;
    height: 60px;
    padding: 10px;
`;

export const Row = styled(Row_)`
    margin: 10px 0px 0px 0px;
    width: 100%;
`;

export const Title = styled.div`

`;
